<template>
    <BContainer fluid v-if="ready" class="p-0 wrapper-embed">

        <div>
            <MapProperties :properties="[property]" />
        </div>

        
        <BRow class="no-gutters justify-content-between align-items-center property-container"
              :data-index="property.index"
              :data-thumbnail="property.url"
              :key="property.url">
  
  
            <BCol cols="12" md="6"
                  class="accordion item-gallery-effect "
                  role="tablist">
  
                                         
                  <div class="text-intro pt-3">
                    <div class="d-flex align-self-center">
                      <a href="https://www.icij.org/investigations/caspian-cabals/kulibayev-nazarbayev-european-properties/" target="_parent"><img :src="`properties/gallery/${property.extra_images[0]}`" width="100%"  />
                          </a>
                    </div>                                 
              </div>

  
            </BCol>
            <BCol cols="12" md="6"
                  class="accordion item-gallery-effect "
                  role="tablist">
  
                                         
                  <div class="text-intro pt-3">
                    <div class="d-flex align-self-center">
                      
                        <div class="p-3">
                          <h5 class="font-weight-300 text-primary fs-20px name-property">
                             
                              {{ property.title }}
                              
                          </h5>
                        <h2 v-if="property.name" v-b-modal="`modal_${property.index}`"
                            class="text-dark case_title name-property fs-xl-19px fs-lg-19px fs-md-19px fs-19px text-capitalize">
                              
                              <a class="text-dark" href="https://www.icij.org/investigations/caspian-cabals/kulibayev-nazarbayev-european-properties/" target="_parent">
                                  {{property.name }} 
                              </a>
                          </h2>

                            <div>
                               <label><strong>City:</strong> </label>
                               <div>{{ property.city }} ({{ property.country }})</div>
                            </div>

                            <div>
                                <label><strong>Price of purchase:</strong></label>
                              <div>{{ property.price_purchase }}</div>
                            </div>
                            
                        </div>
                    </div>                                 
              </div>

  
            </BCol>
        </BRow>
  
              <embeddable-footer class="position-relative" :sharing-options-values="{ url: 'https://www.reddit.com/submit?url=https%3A%2F%2Ficij.org' }">
                  <template #sharing-button>
                      <a class="p-1 btn-primary fs-16px" href="https://www.icij.org/investigations/caspian-cabals/kulibayev-nazarbayev-european-properties" target="_parent"> {{ $t('modal.btn_read') }} </a>
                  </template>
              </embeddable-footer>
  
    </BContainer>
  </template>
  
  <script>
  
    import providerMixin from '@/mixins/property'
    import utils from '@/mixins/utils'
    import { kebabCase } from "lodash";
  
    export default {
        name: 'property',
        mixins: [utils, providerMixin],
        data() {
            return {
              ready: false,
              sharingOptionsValues: {}
            }
        },
        props: {
            content: {
                type: Object
            }
        },
        computed: {
          scaleEmbed() {
              if(window.innerWidth < 560)
                  return this.property.scale * .6
              return this.property.scale * .5
          }
        },
        mounted() {
            this.$nextTick(() => {
                this.ready = true;
            })
        },
        methods: {
          kebabCase
        }
    }
  
  </script>
  
  
  <style lang="scss">
    #app{
        overflow: hidden;
        position: relative;
        width: 100%;
        min-height: 100vh;
        scroll-behavior: smooth;
        background: rgb(147,230,255);
        background: linear-gradient(40deg, #66b9d1 19%, #fdea2c 99%);
    }

    .btn-primary {
        background-color: #12acc2;
        
        &:hover {
            background-color: #feea2c;
            color: #000;
        }
    }

      .wrapper-embed {
          max-width: 620px;
  
          .property-container {
          }
  
          .embeddable-footer {
              &__brand {
                  text-transform: uppercase;
                  font-weight: 400;
                  border: none;
                  font-family: var(--app-headline-font);
                  font-weight: 400;
                  font-style: normal;
                  font-size: 16px;
              }
          }
  
          .name-property {
            font-family: "Poppins";
              font-weight: 900;
              font-style: normal;
              font-size: 21px;
          }
      }
  
      .intro-embed {
          font-size: 14px;        
      }
    .card-image {
        width: 200px;
        cursor: url(~@/assets/img/plus.svg), auto;
        overflow: hidden;
        background-color: var(--app-color-white);
        &:focus {
            outline: none;
        }
        .__case-pic {
            width: 100%;
            height: auto;
        }
        @media (max-width: 720px) {
            .__case-pic {
                height: 27vh;
            }
        }
    }
    .--btn-modal {
        border: none;
        background-color: unset;
        color: var(--app-color-secondary);
        text-decoration-line: underline;
        font-weight: bold;
        &:focus {
            outline: none;
        }
    }
  
    @media (min-width: 1465px) {
        .container, .container-sm, .container-md, .container-lg, .container-xl {
            max-width: 1400px;
        }
    }
    .text-end {
        text-align: end !important;
    }
      .btn-read-more{
        background-color: var(--app-color-red);
        color: white;
        padding: .3rem 1.5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        &:hover,&:focus{
            opacity: .9;
        }
    }
  
    .map_embed {
      position: absolute;
      width: 100%;
      max-height: 320px;
      overflow: hidden;
  
      .map_container_embed svg {
          background-color: #000 !important;
          path.active-residency {
              fill: var(--app-color-red) !important;
          }
      }
    }
  
    @media (max-width: 570px) {
      .card-image {
          width: 100%;
          margin: 0 auto;
      }
  }
  </style>
  